export default function formatPlural(count: number, singleMessage: string, pluralMessage: string, replacer?: string): string {
    let stringToReturn = ''
    if (count === 1) {
      stringToReturn = singleMessage
    } else {
      stringToReturn = pluralMessage
    }
  
    if (replacer) {
        stringToReturn = stringToReturn.replace(replacer, String(count))
    }
  
    return stringToReturn
  }